export const inertiaDefaults = {
  form: {
    forceIndicesArrayFormatInFormData: false,
  },
  future: {
    useScriptElementForInitialPage: true,
    useDataInertiaHeadAttribute: true,
    useDialogForErrorModal: true,
    preserveEqualProps: true,
  },
} as const
